module.exports = __webpack_public_path__ + "img/u76.d333b399.png";